import React, { Component } from 'react';
import Waypoint from 'react-waypoint';
import glamorous from 'glamorous'
import Modal from '../common/Modal';
import Container from '../blocks/Container'
import Button from '../blocks/Button'
import ButtonSet from '../blocks/ButtonSet'
import GdprDeletionModal from '../pages/GDPR/GdprDeletionModal'

const TosContent = glamorous.div({
  backgroundColor: '#efefef',
  fontSize: 12,
  marginBottom: 16,
  maxHeight: 250,
  overflowY: 'scroll',
  padding: '0 12px'
})

const disableAccept = (isEuMember, scrollComplete) => {
  return (isEuMember ? !scrollComplete : false)
}

const createMarkup = (should_show, html_text) => {
  if(should_show) {
    return {
      __html: html_text
    }
  }
}

class TosModal extends Component {

  state = {
      tos_scroll_complete: false,
      gdpr_deletion_modal_open: false,
      tos_modal_open: this.props.isOpen
  }

  handleAccept = (e) => {
    const {
      acceptTos,
      tos
    } = this.props;

    acceptTos(tos.item.id);
    this.setState({'tos_modal_open': !this.state.tos_modal_open})
  }

  toggleModals = () => {
    this.setState({'tos_modal_open': !this.state.tos_modal_open})
    this.setState({'gdpr_deletion_modal_open': !this.state.gdpr_deletion_modal_open})
  }

  handleScroll = ({viewportBottom ,event}) => {
    this.setState({tos_scroll_complete: true})
  }

  renderRejectButton = (isEuMember) => {
    if (isEuMember) {
      return(
        <Button
          variant="simple"
          onClick={this.toggleModals}
        >
          Reject
        </Button>)
    }
  }

  render() {

    const {
      profile,
      tos,
      privacyPolicy
    } = this.props

    const {
      tos_scroll_complete
    } = this.state

    return (
      <div>
        <Modal
          openStatus={this.state.tos_modal_open}
          disableClose={true}
        >
          <Container>
            <h3>Terms and Privacy Policy</h3>
            <TosContent id="tos-scrollbox">
              <p
                dangerouslySetInnerHTML={createMarkup(tos.item, tos.item.markdown_body)}
              />
              <Waypoint onEnter={this.handleScroll}/>
              <p
                dangerouslySetInnerHTML={createMarkup(privacyPolicy.item, privacyPolicy.item.text)}
              />
            </TosContent>
            <ButtonSet>
              <Button
                variant="primary"
                onClick={this.handleAccept}
                disabled={disableAccept(profile.is_eu_member, tos_scroll_complete)}
              >
                Accept
              </Button>
              {this.renderRejectButton(profile.is_eu_member)}
            </ButtonSet>
          </Container>
        </Modal>
        <GdprDeletionModal
            isOpen={this.state.gdpr_deletion_modal_open}
            handleClose={this.toggleModals}
            yesBtnMsg='Delete Anyway'
            noBtnMsg='Nevermind'
            profile={this.props.profile}
            requestGdprDeletion={this.props.requestGdprDeletion}
            hasError={this.props.gdprDeletionError}
          />
      </div>
    )
  }
}

export default TosModal



// WEBPACK FOOTER //
// ./src/components/common/TosModal.jsx